import { apiClient } from "..";
import { ShipmentByRoundRequest, ShipmentByRoundResponse, ShipmentRoundRequest, ShipmentRoundResponse } from "../types/shipment";

export class ShipmentService {
  static async getListByRound(payload: ShipmentByRoundRequest): Promise<ShipmentByRoundResponse> {
    return apiClient.post<ShipmentByRoundResponse>("/shipbyround/list", payload);
  }

  static async processRound(payload: ShipmentRoundRequest): Promise<ShipmentRoundResponse> {
    return apiClient.post<ShipmentRoundResponse>("/shipbyround/round", payload);
  }
}
